export default requester => {
    return {
        /**
         * Search by topics
         **/
        search (params = {}) {
            return requester.get(`/search/topics`, { params });
        },

        /**
         * Get topic by id
         **/
        find (id, params = {}) {
            return requester.get(`/content/topics/${id}`, { params });
        },

        /**
         * Update topic by id
         **/
        update (id, payload) {
            return requester.put(`/content/topics/${id}`, payload);
        },

        /**
         * Remove topic by id
         **/
        remove (id) {
            return requester.delete(`/content/topics/${id}`);
        },

        /**
         * 
         **/
        perform (id, payload) {
            return requester.patch(`/content/topics/${id}`, payload);
        },
    };
}
